import CloudRepository from "./CloudRepository";
const SENDMAIL = "sendVerificationLinkMail";
export default {
  sendMail(detail) {
    return CloudRepository.post(`${SENDMAIL}`,detail);
  },
};
